// frontend/src/components/Automations/describeSchedule.js
// Plain-English schedule label for an automation's trigger. Pure, no deps.
const DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

function clock(min, hr) {
  const h = Number(hr), m = Number(min);
  if (!Number.isInteger(h) || !Number.isInteger(m) || h < 0 || h > 23 || m < 0 || m > 59) return null;
  const ampm = h < 12 ? 'AM' : 'PM';
  const h12 = h % 12 === 0 ? 12 : h % 12;
  return `${h12}:${String(m).padStart(2, '0')} ${ampm}`;
}

function describeCron(expr) {
  const parts = String(expr).trim().split(/\s+/);
  if (parts.length !== 5) return null;
  const [min, hr, dom, mon, dow] = parts;
  // every N minutes
  const everyMin = /^\*\/(\d+)$/.exec(min);
  if (everyMin && hr === '*' && dom === '*' && mon === '*' && dow === '*') {
    return `Every ${everyMin[1]} minutes`;
  }
  // hourly
  if (min === '0' && hr === '*' && dom === '*' && mon === '*' && dow === '*') return 'Hourly';
  // daily at clock time
  if (dom === '*' && mon === '*' && dow === '*') {
    const t = clock(min, hr);
    return t ? `Daily at ${t}` : null;
  }
  // weekly on a single weekday
  if (dom === '*' && mon === '*' && /^[0-6]$/.test(dow)) {
    const t = clock(min, hr);
    return t ? `Weekly on ${DAYS[Number(dow)]} at ${t}` : null;
  }
  return null;
}

export function describeSchedule(triggerType, triggerExpr, tz) {
  if (triggerType === 'interval') {
    const s = Number(triggerExpr);
    if (!Number.isFinite(s) || s <= 0) return `Interval: ${triggerExpr}`;
    if (s % 3600 === 0) return `Every ${s / 3600} hour${s / 3600 > 1 ? 's' : ''}`;
    if (s % 60 === 0) return `Every ${s / 60} minute${s / 60 > 1 ? 's' : ''}`;
    return `Every ${s} seconds`;
  }
  if (triggerType === 'once') {
    const d = new Date(triggerExpr);
    return Number.isNaN(d.getTime()) ? `Once: ${triggerExpr}` : `Once on ${d.toLocaleString()}`;
  }
  if (triggerType === 'cron') {
    return describeCron(triggerExpr) || `Cron: ${triggerExpr}`;
  }
  return `${triggerType}: ${triggerExpr}`;
}
